export default {
  AVAILABLE: 'AVAILABLE',
  NOT_READY: 'NOT_READY',
  NONE: '-',
  PARASITE: 'PARASITE',
  TOO_OLD: 'TOO_OLD',
  WAITING_FOR_CONFIRM: 'WAITING_FOR_CONFIRM'
}
